import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  REVEAL_DELAY = 100
  LOADING_DELAY = 800
  FINAL_WAITING_STEP = 500

  static targets = ['revealItem', 'loadingItem', 'toggleBusyItem', 'editableItem', 'editableItems', 'editableForm']

  static values = {
    customDelay: Number,
    redirectUrl: String, // Because we might have a custom redirect for "qualification" page.
    frameId: String
  }

  connect () {
    if (this.element.getAttribute('aria-busy') !== 'true') {
      return
    }

    this.currentIndex = 0
    this.#processNextItem()
  }

  disconnect () {
    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }
  }

  #processNextItem () {
    const revealItem = this.revealItemTargets[this.currentIndex]
    const loadingItem = this.loadingItemTargets[this.currentIndex]

    if (!revealItem || !loadingItem) {
      this.#onAllItemsComplete()
      return
    }

    revealItem.removeAttribute('hidden')

    this.timeout = window.setTimeout(() => {
      if (this.hasEditableItemsTarget && this.#isLastLoadingItem(loadingItem)) {
        this.editableItemTargets.forEach((editableItem) => {
          editableItem.setAttribute('hidden', true)
        })
        if (this.hasEditableFormTarget) {
          this.editableFormTarget.removeAttribute('hidden')
        }
        this.loadingItemTargets[0].removeAttribute('aria-busy')
      }

      loadingItem.removeAttribute('aria-busy')

      this.currentIndex++
      this.timeout = window.setTimeout(() => {
        this.#processNextItem()
      }, this.customDelayValue || this.REVEAL_DELAY)
    }, this.customDelayValue || this.LOADING_DELAY)
  }

  #onAllItemsComplete () {
    this.element.setAttribute('aria-busy', 'false')

    if (!this.hasEditableItemsTarget && this.redirectUrlValue) {
      return window.Turbo.visit(
        this.redirectUrlValue, {
          frame: this.frameIdValue,
          action: 'replace'
        }
      )
    }

    window.setTimeout(() => {
      this.toggleBusyItemTargets.forEach((toggleBusyItem) => {
        toggleBusyItem.setAttribute('aria-busy', 'false')
      })
    }, this.customDelayValue || this.FINAL_WAITING_STEP)

    window.clearTimeout(this.timeout)
    this.timeout = null
  }

  #isLastLoadingItem (loadingItem) {
    return loadingItem === this.loadingItemTargets[this.loadingItemTargets.length - 1]
  }
}
